"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginActions = void 0;
var constants_1 = require("../../../../constants");
var server_1 = require("../../../../helpers/server");
var model_1 = require("../../../../model");
var store_1 = require("../../../../store");
var USER_NO_PORTAL_TYPE_ERROR = 'Uw inloggegevens zijn niet geldig om in te loggen.';
var LoginActions = /** @class */ (function () {
    function LoginActions() {
    }
    LoginActions.authenticate = function (parameters) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: (0, server_1.apiActions)(LoginActions.LOGIN).request,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.LOGIN_URI, parameters, false)];
                    case 2:
                        result = (_a.sent()).result;
                        // Case we use only portal or user with actions in the app.
                        if (result.user.type !== model_1.UserType.PORTAL || (0, model_1.userActions)(result.user).length === 0) {
                            dispatch({
                                type: (0, server_1.apiActions)(LoginActions.LOGIN).fail,
                                payload: USER_NO_PORTAL_TYPE_ERROR,
                            });
                            return [2 /*return*/];
                        }
                        dispatch({
                            type: (0, server_1.apiActions)(LoginActions.LOGIN).success,
                            payload: result,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(LoginActions.LOGIN).fail,
                            payload: error_1,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    LoginActions.updateProfile = function (userId, user) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var params, result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(LoginActions.PROFILE_UPDATE).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = "".concat(userId, "?returnUpdated=1");
                        return [4 /*yield*/, (0, server_1.put)(constants_1.API.USERS_URI, params, __assign({}, user))];
                    case 2:
                        result = _a.sent();
                        if (result.result) {
                            dispatch({ type: (0, server_1.apiActions)(LoginActions.PROFILE_UPDATE).success, payload: result });
                        }
                        else {
                            dispatch({ type: (0, server_1.apiActions)(LoginActions.PROFILE_UPDATE).fail, payload: result });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(LoginActions.PROFILE_UPDATE).fail, payload: error_2 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    LoginActions.logout = function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch({
                    type: LoginActions.LOGOUT,
                });
                store_1.persistor.purge(); // clear all redux data
                // reload page to stop all side effects
                // todo: stop side effects the right way
                window.location.reload();
                return [2 /*return*/];
            });
        }); };
    };
    LoginActions.LOGIN = 'LOGIN';
    LoginActions.LOGOUT = 'LOGOUT';
    LoginActions.PROFILE_UPDATE = 'PROFILE_UPDATE';
    return LoginActions;
}());
exports.LoginActions = LoginActions;
